import React from 'react';

const BgImage = (props) => {
	return (
	<div className="BgImage">
		{
				props.bgImage &&
				<div className="BgImage">
					<img src={props.bgImage} alt=""/>
				</div>
		}
		{
			props.bgImage2 &&
				<div className="BgImage">
					<img src={props.bgImage2} alt=""/>
				</div>
		}
	</div>
	)
}

export default BgImage;


// WEBPACK FOOTER //
// ./src/components/bgimage.js